import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Paper,
  Divider,
  Button,
  IconButton,
  Pagination,
  PaginationItem,
  Stack,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import ActiveAddButton from "../../../assets/icons/ActiveAddButton.svg";
import { useDispatch, useSelector } from "react-redux";
import EditButton from "../../../assets/icons/EditButton.svg";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TrashButton from "../../../assets/icons/TrashButton.svg";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import AddChecklistTypeMasterModel from "./AddChecklistTypeMasterModel";
import DeleteModel from "../../CommonComponent/DeleteModel";
import {
  deleteChecklistTypeMastersList,
  getChecklistTypeMastersList,
} from "../../../redux/actions/mastersAction";
import EditChecklistTypeMasterModel from "./EditChecklistTypeMasterModel";
import moment from "moment";
import {
  setIsOpenModelAddChecklistTypeMaster,
  setIsOpenModelEditChecklistTypeMaster,
} from "../../../redux/actions/mastersAction";
import { setLoaderSaveButton } from "../../../redux/actions/userActions";
import noData from "../../../assets/images/Group 688.png";
import { TOTALLIMIT } from "../../../utils/localStorage";

const ChecklistTypeMasterContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const checklistTypeMasterPagination = useSelector(
    (state) => state?.masters?.checklistTypeMasterPagination
  );

  const isLoading = useSelector((state) => state?.user?.isLoading);
  const [isdeleteModel, setIsdeleteModel] = useState(false);
  const [checklistMasterDeleteID, setChecklistMasterDeleteID] = useState("");

  const checklistTypeMasterData = useSelector(
    (state) => state?.masters?.checklistTypeMasterData
  );

  const [isPaginationLimit, setIsPaginationLimit] = useState(10);
  const [page, setPage] = useState(1);

  const handleChangeIsPaginationLimit = (event) => {
    setIsPaginationLimit(event.target.value);
  };

  const handleChangePage = (e, pagevalue) => {
    setPage(pagevalue);
  };

  const handleDeleteVesselType = () => {
    dispatch(
      deleteChecklistTypeMastersList({
        id: checklistMasterDeleteID,
      })
    );
    handleClosedeleteModel();
  };

  const handleClosedeleteModel = (e) => {
    setIsdeleteModel(false);
  };

  const handleEditChecklistType = (ChecklistTypeRowData) => {
    const payload = {
      isOpenEditModel: true,
      EditRowDataModel: ChecklistTypeRowData,
    };
    dispatch(setIsOpenModelEditChecklistTypeMaster(payload));
  };

  useEffect(() => {
    dispatch(setIsOpenModelAddChecklistTypeMaster(false));
    const payload = {
      isOpenEditModel: false,
      EditRowDataModel: [],
    };
    dispatch(setIsOpenModelEditChecklistTypeMaster(payload));
    dispatch(setLoaderSaveButton(false));
  }, []);

  useEffect(() => {
    dispatch(
      getChecklistTypeMastersList({
        limit: isPaginationLimit,
        offset: page - 1,
      })
    );
  }, [isPaginationLimit, page]);

  return (
    <>
      <AddChecklistTypeMasterModel />

      <EditChecklistTypeMasterModel />

      {isdeleteModel && (
        <DeleteModel
          isdeleteModel={isdeleteModel}
          handleClosedeleteModel={handleClosedeleteModel}
          handleDelete={handleDeleteVesselType}
        />
      )}
      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/masters");
              }}
            >
              <img src={BackArrow} alt="" width="17" height="17" />
            </Box>
            <Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Checklist Type Master
              </Typography>
            </Box>
          </Box>

          {/* <Box sx={{ display: "flex", alignItems: "center", mr: 6 }}>
            <Button
              variant="outlined"
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                borderColor: "#26875C",
                width: "6rem",
                backgroundColor: "FFFFFF",
                padding: "6px 0px 4px 0px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#26875C",
                ":hover": {
                  borderColor: "#26875C",
                },
              }}
              onClick={() =>
                dispatch(setIsOpenModelAddChecklistTypeMaster(true))
              }
            >
              <Box sx={{ marginRight: "10px" }}>
                <img src={ActiveAddButton} alt="" />
              </Box>
              Add
            </Button>
          </Box> */}
        </Box>
        <Divider sx={{ width: "auto" }} />

        <Box sx={{ margin: "10px 25px 20px 25px" }}>
          <TableContainer
            sx={{
              maxHeight: "620px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {checklistTypeMasterData.length <= 0 ? (
              <Grid sx={{ paddingTop: "20px" }}>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      component="img"
                      sx={{
                        height: "25rem",
                        width: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      alt=""
                      src={noData}
                    />
                  </Box>
                  <Box
                    fontWeight="600"
                    sx={{ padding: "20px", fontWeight: "600" }}
                  >
                    <Typography sx={{ fontWeight: "600", fontSize: "18px" }}>
                      No Data Found
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Checklist Type Name
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Department Name
                    </TableCell>
                    <TableCell
                      sx={{
                        // color: "#B5B5C3",
                        // fontWeight: 600,
                        whiteSpace: "nowrap",
                        // display: "flex",
                        gap: "2px",
                      }}
                    >
                      <Box sx={{ display: 'flex', gap: "3px" }}>
                        <Box sx={{ color: "#B5B5C3", fontWeight: 600 }}>
                          Frequency
                        </Box>

                        <Box sx={{ color: "red", FontSize: "14px" }}>
                          (In Days)
                        </Box>
                      </Box>
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Publish Date
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Time
                    </TableCell> */}
                    <TableCell
                      sx={{
                        // color: "#B5B5C3",
                        // fontWeight: 600,
                        whiteSpace: "nowrap",
                        // display: "flex",
                        gap: "2px",
                      }}
                    >
                      <Box sx={{ display: 'flex', gap: "3px" }}>
                        <Box
                          sx={{
                            color: "#B5B5C3",
                            // FontSize: "14px",
                            fontWeight: 600,
                          }}
                        >
                          Grace Period
                        </Box>

                        <Box sx={{ color: "red", FontSize: "14px" }}>
                          (In Days)
                        </Box>
                      </Box>
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Action
                    </TableCell> */}
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  <TableBody>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "10rem",
                      }}
                    >
                      <TableCell colSpan={8} align="center">
                        <CircularProgress color="success" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {checklistTypeMasterData?.map((row, index) => (
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {row?.name}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {row?.department_info?.name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.set_trigger}
                        </TableCell>
                        {/* <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {moment(row?.publish_date).format("D MMMM, YYYY")}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {moment(row?.publish_date).format("hh:mm A")}
                        </TableCell> */}
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.grace_period}
                        </TableCell>
                        {/* <TableCell
                          sx={{
                            color: "#464E5F",

                            fontWeight: 600,

                            display: "flex",
                          }}
                        >
                          <IconButton>
                            <img
                              src={EditButton}
                              width="30"
                              height="30"
                              onClick={() => handleEditChecklistType(row)}
                            />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setChecklistMasterDeleteID(row?.id);
                              setIsdeleteModel(true);
                            }}
                          >
                            <img src={TrashButton} width="30" height="30" />
                          </IconButton>
                        </TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            )}
          </TableContainer>
          <Divider />
          {checklistTypeMasterPagination?.totalRecord >= TOTALLIMIT && (
            <Stack
              spacing={2}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{
                padding: "1rem",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
                <Select
                  value={isPaginationLimit}
                  onChange={handleChangeIsPaginationLimit}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={() => (
                    <Box
                      sx={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ArrowDown}
                        alt="Custom Icon"
                        width="18"
                        height="24"
                      />
                    </Box>
                  )}
                  sx={{
                    height: "37px",
                    width: "6rem",
                    color: "#20724E",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#E5F1EB",
                    mr: 2,
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E5F1EB",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                </Select>
              </Box>
              <Box>
                <Pagination
                  count={checklistTypeMasterPagination?.totalPages}
                  onChange={handleChangePage}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Box>
            </Stack>
          )}
        </Box>
      </Paper>
    </>
  );
};

export default ChecklistTypeMasterContent;
